import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSeat = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.3333 9.46665V4.66665C18.3333 3.93331 17.7333 3.33331 17 3.33331H7C6.26667 3.33331 5.66667 3.93331 5.66667 4.66665V9.46665C4.70667 9.75331 4 10.6333 4 11.6933V17.36C4 18.0933 4.6 18.6933 5.33333 18.6933H5.9V20.7533H7.23333V18.6933H16.76V20.7533H18.0933V18.6933H18.66C19.3933 18.6933 19.9933 18.0933 19.9933 17.36V11.6933C19.9933 10.64 19.2867 9.75998 18.3267 9.46665H18.3333ZM8.66667 13.3466V11.6933C8.66667 10.64 7.96 9.75998 7 9.46665V4.66665H17V9.46665C16.04 9.75331 15.3333 10.6333 15.3333 11.6933V13.3466H8.66667ZM18.6667 17.36H5.33333V11.6933C5.33333 11.14 5.78 10.6933 6.33333 10.6933C6.88667 10.6933 7.33333 11.14 7.33333 11.6933V14.68H16.6667V11.6933C16.6667 11.14 17.1133 10.6933 17.6667 10.6933C18.22 10.6933 18.6667 11.14 18.6667 11.6933V17.36Z",
		fill: "currentColor"
	})
});
export default SvgSeat;
